import { FormikProps } from 'formik';

import {
  emptyScheduleValues,
  hasSchedule,
  IBroadcastScheduleValues,
} from '../../../components/Admin/BroadcastList/CreateEditBroadcastNotification/BroadcastFields/BroadcastScheduleFields/helper';

const useBroadcastSchedule = <T extends IBroadcastScheduleValues>(
  formik: FormikProps<T>,
) => {
  const isScheduled = hasSchedule(formik.values);

  const handleClearSchedule = () => {
    formik.setValues((values) =>
      ({ ...values, ...emptyScheduleValues }));
  };

  return { isScheduled, handleClearSchedule };
};

export default useBroadcastSchedule;
